import CampaignsView from "../../components/Campaigns/Index";
import {
  getTables,
  getCampaignById,
  getCampaignCSV,
  clearCampaignDetail,
  clearCampaignCsvData,
  setCampaignFilterEndDate,
  setCampaignFilterStartDate,
  setCampaignFilterValue,
} from "../../actions/Campaign";
import { selectClient } from "../../actions/App";
import { connect } from "react-redux";

const mapStateToProps = state => {
  const {
    tables,
    emailChannelCampaigns,
    socialChannelCampaigns,
    campaignDataOnLoading,
    csvData,
    campaignDataLoadErrorMessage,
    campaignFilterStartDate,
    campaignFilterEndDate,
    campaignFilterValue,
  } = state.campaigns;
  const { roleId } = state.app;
  return {
    client_id: state.app.client_info && state.app.client_info.id,
    client_tz: state.app.client_info && state.app.client_info.timezone,
    client_info: state.app.client_info,
    clients: state.app.clients,
    tables: tables,
    csvData: csvData,
    campaignDataOnLoading,
    emailChannelCampaigns,
    socialChannelCampaigns,
    campaignDataLoadErrorMessage,
    campaignFilterStartDate,
    campaignFilterEndDate,
    campaignFilterValue,
    roleId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTables: obj => {
      if (!obj.fromDate && !obj.toDate) obj.status = "Active";
      else obj.status = undefined;
      dispatch(getTables(obj));
    },

    getCampaignById: (id, clientId) => {
      dispatch(getCampaignById(id, true, clientId));
    },

    clearCampaignDetail: () => {
      dispatch(clearCampaignDetail());
    },

    clearCampaignCsvData: () => {
      dispatch(clearCampaignCsvData());
    },

    getCampaignCsvData: obj => {
      if (!obj.fromDate && !obj.toDate) obj.status = "Active";
      else obj.status = undefined;
      dispatch(getCampaignCSV(obj));
    },

    setCampaignFilterStartDate: date => {
      dispatch(setCampaignFilterStartDate(date));
    },

    setCampaignFilterEndDate: date => {
      dispatch(setCampaignFilterEndDate(date));
    },

    setCampaignFilterValue: filterValue => {
      dispatch(setCampaignFilterValue(filterValue));
    },
    selectClient: id => {
      dispatch(selectClient(id));
    },
  };
};

const Campaigns = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CampaignsView);

export default Campaigns;



// WEBPACK FOOTER //
// ./src/containers/Campaigns/index.js